import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { AvailableLang } from '@app/core/const/i18n';
import { AppActions } from '@app/store/actions';
import * as fromRoot from '@app/store/reducers';
import { AvailableLangs, TranslocoService } from '@jsverse/transloco';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'am-lang-menu',
  templateUrl: './lang-menu.component.html',
  styleUrls: ['./lang-menu.component.scss'],
  imports: [MatButton, MatMenuTrigger, MatMenu, MatMenuItem, AsyncPipe, UpperCasePipe],
  standalone: true,
})
export class LangMenuComponent implements OnInit {
  availableLangs: AvailableLangs;

  activeLang$: Observable<string>;

  private readonly _store = inject<Store<fromRoot.State>>(Store);
  private readonly _translocoService = inject(TranslocoService);

  ngOnInit(): void {
    this.availableLangs = this._translocoService.getAvailableLangs();
    this.activeLang$ = this._translocoService.langChanges$;
  }

  langChanged(lang: string): void {
    this._store.dispatch(AppActions.updateLanguage({ currentLang: lang as AvailableLang }));
    this._translocoService.setActiveLang(lang);
  }
}
